<template>
    <div class="marketingCenter spackage padding-20 bgc box-shadow">

        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1">短信发送</el-menu-item>
        </el-menu>

        <section class="cz">
            <p class="name">账户余额</p>
            <p class="money">¥ {{ allbalance }}</p>
            <el-button type="warning" @click="dialogVisible = true">充值</el-button>
        </section>

        <section>
            <el-steps :active="active" finish-status="success"  align-center>
                <el-step title="选择联系人"></el-step>
                <el-step title="编辑短信"></el-step>
                <el-step title="发送成功"></el-step>
            </el-steps>


            <template v-if="active == 0">

                <div class="choose-contacts">
                    <div class="choose-contacts-left">
                        <p class="name">筛选联系人</p>

                        <div class="choose-position">
                            <el-select v-model="selectValue" placeholder="请选择" style="width: 160px;margin-right: 20px">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <el-input v-model="telValue" placeholder="输入手机号/姓名" style="width: 240px;margin-right: 20px"></el-input>
                            <el-button type="primary" plain @click="search()">搜索</el-button>
                        </div>

                        <el-table
                            ref="selectValue"
                            :data="tableData"
                            tooltip-effect="dark"
                            @select="selectChange"
                            @select-all="selectAll">
                            <!--@selection-change="handleSelectionChange"-->
                            <el-table-column
                                type="selection"
                                width="55">
                            </el-table-column>
                            <el-table-column label="序号" width="120">
                                <template slot-scope="scope">
                                    {{ (scope.$index + 1 ) + ((dataApi.page - 1) * 10) }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="昵称">
                            </el-table-column>
                            <el-table-column
                                prop="fansource"
                                label="来源"
                                show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column
                                prop="mobileno"
                                label="手机号"
                                show-overflow-tooltip>
                            </el-table-column>
                        </el-table>

                        <p class="num">已选中 {{ multipleSelection.length }} 名</p>


                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="rowCount" align="center" @current-change="fPage()" :current-page.sync="currentPages" tyle="margin-top:20px">
                        </el-pagination>
                        <!--<el-button class="submit" type="primary" @click="define()">确定</el-button>-->

                    </div>
                    <div class="choose-contacts-right">
                        <p class="name">手动添加</p>
                        <div>
                            <el-input v-model="stelValue" placeholder="请输入手机号" style="width:calc(100% - 116px);margin-right: 20px;"></el-input>
                            <el-button type="primary" @click="addIphone()" plain>添加</el-button>
                        </div>

                        <p class="name" style="margin: 30px 0 10px 0;">已选联系人</p>

                        <el-table
                            ref="multipleTable"
                            :data="multipleSelection"
                            tooltip-effect="dark">

                            <el-table-column
                                prop="name"
                                label="昵称">
                            </el-table-column>
                            <el-table-column
                                prop="mobileno"
                                label="手机号"
                                show-overflow-tooltip>
                            </el-table-column>

                            <el-table-column align="right">
                                <template slot-scope="scope">
                                    <p v-if="scope.row.name == ''" @click="delIphone(scope.row.innerid)">删除</p>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button class="relation" @click="clearMultipleSelection()">重置</el-button>
                    </div>
                </div>

            </template>
            <template v-if="active == 1">

                <div class="choose-contacts">
                    <div class="choose-contacts-left two">

                        <div class="title">
                            <p class="select-num">已选人数:</p>
                            <p>短信内容:</p>
                        </div>

                        <div class="block">
                            <p class="select-num">{{ multipleSelection.length }}人</p>
                            <div class="txt">
                                <el-input type="textarea" :class="{'error-textarea':dxMessage.status}" :rows="3" v-model="textarea" placeholder="请输入内容" size="31" maxlength="31" show-word-limit></el-input>
                                <!-- class="error-textarea"-->
                                <p class="error-p" v-if="dxMessage.status == true">{{dxMessage.message}}</p>
                                <!--您的信息内容已涉及到相关敏感词，请修改后再进行发送-->
                                <!--请输入短信内容-->

                                <el-alert title="提示：每60字 ¥0.1 元（字数统计含默认内容、英数字、空白、标点符号及活动行签名）" type="info" show-icon></el-alert>
                            </div>
                            <el-button type="primary" @click="getMe()">发给自己</el-button>
                        </div>
                    </div>
                    <div class="choose-contacts-right two">

                        <div class="iphone-bg1">
                            <div class="iphone-bg2">
                                <p>{{textarea}}</p>
                            </div>
                        </div>
                    </div>
                </div>


            </template>
            <template v-if="active == 2 || active == 3">
               <div class="status-icon">

                   <template v-if="dxstaus == false">
                       <i class="el-icon-error"></i>
                       <p>提交失败</p>
                   </template>
                  <template v-else>
                      <i class="el-icon-success"></i>
                      <p>提交成功</p>
                  </template>
               </div>
            </template>

            <div class="btn-list-block">
                <div class="btnlist">
                    <el-button v-if="active > 0 && active < 2"  @click="last">上一步</el-button>

                    <template v-if="active == 3 || active == 2">
                        <el-button type="primary" @click="goto()">返回</el-button>
                    </template>
                    <el-button v-else type="primary" @click="next">下一步</el-button>
                </div>
            </div>
        </section>


        <el-dialog title="充值金额" class="recharge" :visible.sync="dialogVisible">
            <div class="top">
                <p class="title">充值金额</p>
                <template v-for="item in moneyList" >
                    <input type="radio" name="money" :id="'money_'+item">
                    <label :for="'money_'+item" @click="checkMoney = item; money = ''">
                        <p>{{item}}</p>
                    </label>
                </template>
            </div>
            <div class="bottom">
                <p class="title">自定义金额</p>
                <el-input type="tel" v-model="money" placeholder="输入金额" width="166px" @input="clearRadio"></el-input>
                <p>输入金额需大于0小于9999的整数</p>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitMoney">确 定</el-button>
             </span>
        </el-dialog>
        <!-- end 充值弹窗 -->


        <el-dialog title="充值状态" class="cz-status" :before-close="czhandleClose" :visible.sync="czialogVisible" >

             <section class="item-1" v-if="czStatus == 1">
                 <img class="success" src="../../common/images/markeingcenter/success.png" alt="查询支付">
                 <p>正在查询支付结果</p>
                 <img class="item-loading" src="../../common/images/markeingcenter/loading.svg" alt="example">

                 <span slot="footer" class="dialog-footer">
                    <el-button @click="clearczialogVisible">关闭窗口</el-button>
                    <el-button type="primary" @click="selectCzStatus">支付完成</el-button>
                 </span>
             </section>
            <!-- end 查询支付状态 -->

            <section class="cz-status item-2" v-if="czStatus == 2">
                <div class="status-icon">
                    <i class="el-icon-success"></i>
                </div>
                <p class="name">充值成功</p>

                <p><strong>订单号：</strong><span>{{rechargeData.orderno}}</span></p>
                <p><strong>充值金额：</strong><span>{{rechargeData.ordermoney}}元</span></p>
                <p><strong>账户余额：</strong><span>{{rechargeData.allbalance}}元</span></p>

                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = true,czialogVisible = false">继续充值</el-button>
                <el-button type="primary" @click="clearczialogVisible">关闭窗口</el-button>
             </span>
            </section>
             <!-- end 支付成功 -->

            <section class="cz-status item-3" v-if="czStatus == 3">
                <div class="status-icon">
                    <i class="el-icon-error"></i>
                </div>
                <p class="name">支付未完成</p>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="clearczialogVisible">关闭窗口</el-button>
             </span>
            </section>
            <!-- end 支付未完成 -->


        </el-dialog>
        <!-- end 充值弹窗 -->
        <!-- end 充值状态 -->

    </div>
</template>

<script>
import {findAllFans, hostrecharge, sendMessage, queryrechargeresult} from '@/api/marketingCenterApi'; // 引入粉丝管理 api 资源文件
import {getCookie} from '@/common/js/tools';    // 引入 tools 库
import Loading from 'base/loading/loading';    // 引入 loading 组件
import {mapActions} from 'vuex';       // 引入 vuex 组件
import $ from 'jquery';       // 引入 jquery 组件
export default {
    name: "MarketingCenter",
    data() {
        return {
            token: JSON.parse(sessionStorage['user']).loginToken, // token
            shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
            dialogVisible: false,
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            dataApi: {page:1},
            loading: false,
            moneyList: [50,100,500,1000],
            money: '',  // 充值金额
            checkMoney: 0,  // 选中金额
            allbalance: 0,  // 账户余额
            activeIndex: '1', // 初始化页面下标
            textarea: "", // 留言
            active: 0, // 当前页面下标
            rowCount: 0, // 总页数
            currentPages: 1, // 初始化页数
            dxstaus: false, // 短信发送状态
            dxMessage: {status:false, message:''},  // 短信内容状态
            options: [
                {          // 标签 1 关注 2 购买  为空 全部来源
                    value: '',
                    label:"全部来源"
                },{
                    value: 1,
                    label:"关注"
                },{
                    value: 2,
                    label:"购买"
                }
            ], // 标签
            selectValue: '', // 来源选中
            temporaryCheck: '', // 临时联系人选中项
            telValue: '', // 搜索-手机号/姓名
            stelValue: '', // 手动输入手机号码
            tableData: [],  // 联系人列表数据
            multipleSelection: [], // 已选联系人数据
            czialogVisible: false, // 充值查询状态弹窗
            czInterval: '', // 充值遍历
            czStatus: 1, // 充值状态页面
            czDataApi: {}, // 充值api
            rechargeData: {}  // 充值数据
        };
    },
    mounted() {

        // url 地址请求 有参数的情况 初始化已选联系人数据
        if (this.$route.query.data) {
            this.multipleSelection = JSON.parse(this.$route.query.data)
        }

        let dataApi = this.dataApi = {  //接口数据
            LoginToken: this.token,
            ShopID: this.shopID,
            page: 1,
            pageSize: 10
        }

        this.setLoading(true)
        // 连接查询接口
        findAllFans({
            data: dataApi,
            success:data => {
                this.setLoading(false)
                this.allbalance = data.data.allbalance
                this.tableData = data.data.content
                this.rowCount = data.data.pageinfo.rowCount

                // 数据渲染完毕后执行
                this.$nextTick(() => {
                    // 判断联系人是否在 已选联系人序列里
                    this.justSequence(this)
                })

            },
            error:data => {
                this.setLoading(false)
                console.log(data)
            }
        })


    },
    methods: {
        next() {    // 下一步
            let multipleSelection = this.multipleSelection,
                textarea = this.textarea,
                num =  this.active,
                dxMessage = this.dxMessage,
                mobilePhone = ''

            if(num == 0) {  // 第一页
                if (!multipleSelection.length) {
                    this.$message.error('请选择联系人')
                } else {
                    // 下一页
                    this.active ++
                }
            } else if(num == 1) {   // 第二页

                if (textarea.length < 1) {
                    dxMessage.status = true
                    dxMessage.message = '请输入短信内容'
                } else {

                    dxMessage.status = false


                    // 组合手机号码
                    multipleSelection.forEach(json => {
                        mobilePhone += json.mobileno + ','
                    })

                    // 提交内容 发送短信
                    let data = {
                        LoginToken: this.token,
                        ShopID: this.shopID,
                        status: 1,
                        message: textarea,
                        mobilePhone: mobilePhone,
                        sourcetype: 3
                    }

                    this.setLoading(true)
                    sendMessage({
                        data: data,
                        success: data => {

                            this.setLoading(false)
                            // 判断短信是否发送成功
                            if(data.success == true) {
                                this.dxstaus = true
                                this.active ++

                                // 调整余额
                                this.allbalance = data.data
                            } else {
                                this.$message.success('发送短信失败')
                            }

                        },
                        error: data => {

                            this.setLoading(false)
                            if(data.success == true) {
                                this.dxstaus = true
                                this.active ++
                            } else {
                                this.$message.success('发送短信失败')
                            }
                            console.log(data)
                        }
                    })
                }
            } else if ($this.active > 2) {
                $this.active = 0
            }

            // let num = this.active++,
            //     $this = this
            //
            // if(num == 1) {
            //
            //     // 提交内容 发送短信
            //     let data = {
            //         LoginToken: this.token,
            //         ShopID: this.shopID,
            //         status: 1,
            //         // message:'',
            //         mobilePhone:'',
            //         sourcetype: 3
            //     }
            //
            //
            //
            //     console.log('提交')
            //
            //     // $this.active = 3
            // }
            // else if ($this.active > 2) {
            //     $this.active = 0
            // }

        },
        last() {    // 上一步
            let num = this.active --,
                $this = this

            if ( num == 3 ){
                $this.active = 1
            } else if ($this.active < 0) {
                $this.active = 0
            }
        },
        getMe() {   // 短信发送给自己 测试

            let textarea = this.textarea,
                dxMessage = this.dxMessage

            if (textarea.length < 1) {
                dxMessage.status = true
                dxMessage.message = '请输入短信内容'
            } else {

                dxMessage.status = false

                let data = {
                    LoginToken: this.token,
                    ShopID: this.shopID,
                    status: 0,
                    message: textarea,
                    mobilePhone:'',
                    sourcetype: 3
                }

                this.setLoading(true)
                sendMessage({
                    data: data,
                    success: data => {

                        this.setLoading(false)
                        // 判断短信是否发送成功
                        if(data.success == true) {

                            this.$message.success('发送短信成功')

                            // 调整余额
                            this.allbalance = data.data

                        } else {
                            this.$message.success('发送短信失败')
                        }

                    },
                    error: data => {

                        this.setLoading(false)
                        // 判断短信是否发送成功
                        if(data.success == true) {

                            this.$message.success('发送短信成功')

                            // 调整余额
                            this.allbalance = data.data

                        } else {
                            this.$message.success('发送短信失败')
                        }
                        console.log(data)
                    }
                })

            }

        },
        goto() {    // 前往
            this.active = 0
            this.$router.push('/marketingCenter/MarketingCenter')
            this.multipleSelection = []

        },
        selectChange(val,row) { // 单击筛选联系人

            let multipleSelection = this.multipleSelection

            // 已选联系人不为空时
            if( multipleSelection.length ) {

                // 选中的联系人在 已选联系人中存在时 —— 删除该数据， 不存在时 —— 增加数据
                // 假设数据不存在
                let status = false


                multipleSelection.forEach((json,index) => {
                    // console.log(json)
                    // 数据存在 删除
                    if (row.innerid === json.innerid) {
                        multipleSelection.splice(index,1)
                        status = true
                    }
                })

                // 数据不存在 增加
                if (status === false) {
                    multipleSelection.splice(multipleSelection.length,0,row)
                }

            } else {
                this.multipleSelection.splice(0,0,row)
            }
        },
        selectAll(val) {   // 全选联系人

            let multipleSelection = this.multipleSelection,
                tableData = this.tableData

            // 数据存在时 增加 不存在时则删除数据
            if (val.length) {

                let idList = [] // 不存在的数据下标
                val.forEach((vJson,vindex) => {

                    // 数据存在状态 存在时不重复添加数据  默认为不存在
                    let status = false

                    multipleSelection.forEach((mJson,mindex) => {

                        if (vJson.innerid === mJson.innerid) {
                            status = true
                        }
                    })

                    // 数据不存在 增加数据
                    if (status === false) {
                        multipleSelection.splice(multipleSelection.length,0,vJson)
                    }
                })

            } else {

                // 取消全选 取消时 val 值为空 直接使用 tableData 与 multipleSelection 进行判断 内部数据 innerid 相同删除
                tableData.forEach(tJson => {
                    multipleSelection.forEach((mJson,mIndex) => {
                        if (tJson.innerid === mJson.innerid) {
                            multipleSelection.splice(mIndex,1)
                        }
                    })
                })

            }
        },
        search() {  // 搜索
            let searchValue = this.telValue,
                mobileno = '',
                name = '',
                fansource = this.selectValue

            // 判断是否为手机号码
            if(/^0?1[3|4|5|6|7|8][0-9]\d{8}$/.test(searchValue) ) {
                mobileno = searchValue
            } else {
                name = searchValue
            }

            this.dataApi.mobileno = mobileno
            this.dataApi.fansource = fansource
            this.dataApi.name = name
            this.dataApi.page = 1

            this.setLoading(true)
            // 连接查询接口
            findAllFans({
                data: this.dataApi,
                success:data => {

                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.rowCount = data.data.pageinfo.rowCount;

                    // 初始化页数
                    this.currentPages = 1

                    // 判断联系人是否在 已选联系人序列里
                    this.justSequence(this)
                },
                error:data => {

                    this.setLoading(false)
                    console.log(data)
                }
            })

        },
        fPage() {   // 分页跳转
            // this.setLoading(true);
            let clickPage = $(".el-pagination .active").html();
            this.dataApi.page = clickPage;

            this.setLoading(true)
            // 粉丝列表
            findAllFans({
                data: this.dataApi,
                success:data => {

                    // 关闭加载
                    this.setLoading(false)
                    // this.setLoading(false);

                    // 粉丝列表数据渲染
                    this.tableData = data.data.content
                    // 页数设置
                    this.rowCount = data.data.pageinfo.rowCount;

                    // 判断联系人是否在 已选联系人序列里
                    this.justSequence(this)
                },
                error:data => {
                    // 关闭加载

                    // this.setLoading(false);
                    this.setLoading(false)
                    console.log(data)
                }
            })
        },
        justSequence($this) {   // 判断联系人是否在 已选联系人序列里

            // 数据加载完毕时
            $this.$nextTick(function() {
                let tableRows = $this.tableData,
                    multipleRows = $this.multipleSelection
                // 判断数据是否存储在了已选联系人里
                if(multipleRows.length) {
                    tableRows.forEach((row,index) => {
                        multipleRows.forEach(mrow => {

                            // 判断联系人id是否相同   相同则选中筛选联系人内表单数据
                            if(row.innerid === mrow.innerid) {

                                // 选中样式
                                $this.$refs.selectValue.toggleRowSelection(row,true);
                            }

                        })

                    })
                }
            })
        },
        addIphone() {   // 手动添加手机号码
            let stelValue = this.stelValue

            // 手动添加手机号码
            if(/^0?1[3|4|5|6|7|8][0-9]\d{8}$/.test(stelValue) ) {

                // 生成随机 innerid
                let innerid = 'sj' + Math.round(Math.random() * 100000),
                    multipleSelection = this.multipleSelection,
                    status = false

                // 判断随机 innerid 是否存在 存在则再次生成
                function justInnerid() {

                    multipleSelection.forEach(json => {
                        if(json.innerid === innerid) {
                            innerid = 'sj' + Math.round(Math.random() * 1000)
                            justInnerid()
                        }
                    })

                    return
                }
                justInnerid()

                multipleSelection.splice(0,0,{name:'',mobileno:stelValue,innerid:innerid})

            } else {
                this.$message.error("请输入正确的手机号")
            }
        },
        delIphone(innerid) {
            // 删除手动输入的数据
            let multipleSelection = this.multipleSelection

            multipleSelection.forEach((json,index) => {
                if (json.innerid === innerid) {
                    multipleSelection.splice(index,1)
                }
            })


        },
        clearMultipleSelection() {  // 重置已选联系人
            this.multipleSelection = []
            this.$refs.selectValue.clearSelection()
        },
        clearRadio() {
            this.checkMoney = 0
            $("input[name=money]:checked").prop("checked",false)
        },
        submitMoney() {

            let money = this.money,
                checkMoney = this.checkMoney,
                m = 0

            if( money != '') {
                // if(/^[0-9]*[1-9][0-9]*$/.test(money)) {
                if(true) {
                    m = money
                } else {
                    this.$message.error('请输入整数')
                    return
                }
                m = money
            }

            if (checkMoney != 0) {
                m = checkMoney
            }

            if(m === 0) {
                this.$message.error('请选择/输入充值金额')
                return
            }

            let data = {
                LoginToken: this.token,
                ShopID: this.shopID,
                money: m
            }

            this.setLoading(true)
            hostrecharge({
                data: data,
                success:data => {
                    this.setLoading(false)
                    // 打开充值窗口
                    window.open(data.data.url)

                    console.log(data)

                    this.dialogVisible = false
                    // 打开充值弹窗状态查询窗口
                    this.czialogVisible = true

                    this.czDataApi = {
                        LoginToken: this.token,
                        ShopID: this.shopID,
                        orderno: data.data.orderno,
                        sign: data.data.ordersign
                    }

                    // 遍历充值状态
                    this.czInterval = setInterval(()=>{
                        queryrechargeresult({
                            data: this.czDataApi,
                            success:data => {

                                if(data.code == '000') {
                                    clearInterval(this.czInterval)
                                    this.czStatus = 2
                                    this.rechargeData = data.data
                                }
                            },
                            error:data => {
                                console.log(data)
                            }
                        })
                    },30000)


                    // this.$router.push(data.data.url)
                    // location.href = data.data.url
                },
                error:data => {
                    this.setLoading(false)
                    console.log(data)
                }
            })

        },
        czhandleClose() {
            // 触发充值结果弹窗关闭 czInterval
            this.czialogVisible = false
            clearInterval(this.czInterval)
            console.log('关闭clearInterval')
        },
        clearczialogVisible(){
            this.czialogVisible = false
            this.czStatus = 1
            this.rechargeData = {}
            // 触发充值结果弹窗关闭 czInterval
            clearInterval(this.czInterval)
            console.log('关闭clearInterval')
        },
        selectCzStatus() {
            this.setLoading(true)
            // 查询充值结果
            queryrechargeresult({
                data: this.czDataApi,
                success:data => {
                    clearInterval(this.czInterval)
                    this.setLoading(false)

                    if(data.code === "301") {
                        this.czStatus = 3
                    } else if(data.code == '000') {
                        this.czStatus = 2
                        this.rechargeData = data.data
                    }

                },
                error:data => {
                    console.log(data)
                    this.setLoading(false)
                    if(data.code === "301") {
                        this.czStatus = 3
                    }
                }
            })

        },
        ...mapActions (['setLoading'])
    }
}
</script>

<style lang="scss">
    .marketingCenter {
       .btn-list-block {
            display: block;
            width: 100%;
            height: 72px;
            .btnlist {
                position: fixed;
                z-index: 2;
                margin: auto;
                padding: 20px 0;
                bottom: 0;
                right: 0;
                margin-top: 40px;
                margin-right: 20px;
                min-width: 1000px;
                width: calc(100% - 220px );
                text-align: center;
                background: #fff;
            }
        }

    .cz {
        position: relative;
        margin-top: 29px;
        padding: 20px 30px;
        box-sizing: border-box;
        height: 144px;
        background: #F5F7FA;
    .name {
        color: #303133;
        font-size: 16px;
    }
    .money {
        margin-top: 30px;
        color: #303133;
        font-size: 50px;
    }
    .el-button {
        position: absolute;
        margin: auto;
        right: 30px;
        top: 0;
        bottom: 0;
    }
    }

    .recharge {
        .top {
            .title {
                display: inline-block;
                float: left;
                color: #303133;
                line-height: 32px;
            }
            input {
                display: none
            }
            input[type=radio]:checked + label {
                position: relative;
                border-color: #409EFF;
            }

            input[type=radio]:checked + label:after {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                display: block;
                width: 23px;
                height: 23px;
                background: url("../../common/images/starMgtHeaderimg/radio.png") no-repeat center ;
                background-size: 23px;
            }

            label {
                margin-left: 29px;
                display: inline-block;
                width: 95px;
                height: 32px;
                text-align: center;
                cursor: pointer;
                border: 1px solid rgba(220,223,230,1);
                border-radius:2px;

                p {
                    font-size: 14px;
                    color: #606266;
                    line-height: 32px;
                }
            }
        }

        .bottom {
            margin-top: 22px;

            p {
                color: #C0C4CC;
            }
            p,input {
                display: inline-block;
                font-size: 14px;
                line-height: 32px;
            }
            .title {
                float: left;
                color: #303133;
            }

            .el-input {
                margin-left: 15px;
                margin-right: 10px;
                width: 166px;
            }


        }
    }

    .el-steps {
        margin-top: 42px;
        margin-bottom: 30px;

    .el-step__title.is-success {
        color: #409EFF;
    }
    .el-step__head.is-success {
        color: #fff;
        border-color: #409EFF;
    }
    .is-success {
    .el-step__icon.is-text {
        background: #409EFF;
    }
    }
    }

    .choose-contacts {

        border: solid 1px #DCDFE6;
        overflow-y: hidden;

    .el-input__icon {
        height: 36px;
    }
    .name {
        font-size: 16px;
        color: #303133;
    }
    .choose-contacts-left {
        float: left;
        padding: 20px 40px;
        width: calc(60% - 1px);
        border-right: solid 1px #DCDFE6;
        box-sizing: border-box;

    .name {
        margin-bottom: 20px
    }
    .num {
        margin-top: 20px;
    }

    .submit {
        display: block;
        margin: auto;
        margin-top: 40px;
    }
    .el-table {
        margin-top: 20px;
        width: 100%;
        height: 603px;
    }
    }

    .choose-contacts-left.two {

        height: 493px;

    p {
        color: #303133;
        font-size: 14px;
    }
    .select-num {
        margin-bottom: 30px;
    }
    .title {
        float: left;
        width: 70px;
    }
    .block {
        float: right;
        width: calc(100% - 70px);

    .txt {
        margin-bottom: 30px;
        padding: 20px;
        box-sizing: border-box;
        background: #F5F7FA;


    .el-textarea {
        width: 60%;
    .el-input__count {
        right: -45px;
        font-size: 14px;
        bottom: 0;
        background: #F5F7FA;
    }
    }

    .el-alert--info.is-light {
        margin-top: 7px;
        padding-left: 0;
        background: #F5F7FA;

    .el-alert__closebtn {
        display: none;
    }
    }

    .error-textarea textarea {
        border-color: #F56C6C
    }
    .error-p {
        margin-top: 10px;
        color: #F56C6C;
        font-size: 13px;
    }

    }

    }
    }

    .choose-contacts-right.two {
        position: relative;
        padding: 0;
    .iphone-bg1 {
        position: relative;
        margin: auto;
        margin-top: 30px;
        width: 406px;
        height: 463px;
        background:url("./../../common/images/markeingcenter/iphone_bg1.png") no-repeat center;
        background-size: 406px 463px;
    .iphone-bg2 {
        position: absolute;
        padding: 16px 15px;
        margin: auto;
        left: 0;
        right: 0;
        top: 102px;
        width: 291px;
        height: 142px;
        box-sizing: border-box;
        background:url("./../../common/images/markeingcenter/iphone_bg2.png") no-repeat center;
        background-size: 291px 142px;
    }
    }
    }
    .choose-contacts-right {
        float:left;
        padding: 20px 80px;
        width: 40%;
        box-sizing: border-box;

    .name {
        margin-bottom: 10px
    }
    .el-table {
        width: 100%;
        height:632px;
        overflow: scroll;
        background: #F5F7FA;

    th,
    tr {
        background: #F5F7FA;

    p {
        color: #409EFF;
        cursor: pointer;
    }
    }
    }
    .relation {
        display: block;
        margin: auto;
        margin-top: 24px;
    }
    }
    }

    .status-icon {
        height: 403px;
        border: solid 1px #DCDFE6;
        text-align: center;
    i {
        margin-top: 70px;
        font-size: 72px;
    }
    .el-icon-error {
        color: #F56C6C;
    }
    .el-icon-success {
        color: #67C23A;
    }
    p {
        margin-top: 30px;
        font-size: 24px;
        font-weight:500;
        color: #303133;
    }
    }

    .btnlist {
        margin-top: 40px;
        text-align: center;

    .el-button {
        margin-right: 60px;
    }
    }

    .cz-status {
        img {
            display: block;
            margin: auto;
        }
        p {
            margin-top: 15px;
            padding-left: 218px;
            text-align: left;
            font-size: 14px;
            span {
                font-size: 14px;
                color: #606266;
            }
            strong {
                text-align: right;
                width: 70px;
                display: inline-block;
            }
        }
        .el-button {
            margin: auto 15px;
        }

        .item-1 {
            p {
                font-size: 12px;
                color: #409EFF;
            }
            .success {
                width:164px;
                height:138px;
            }

            .item-loading {
                margin-top: 10px;
                width: 66px;
            }
        }
        p.name {
            margin-top: 10px;
            margin-bottom: 10px;
            padding: 0;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            color: #303133;
        }

        .status-icon {
            margin-top: 10px;
            border: none;
            height: 72px;

            i {
                margin: 0;
                font-size: 72px;
            }
        }

        .dialog-footer {
            margin-top: 30px;
            display: block;
            width: 100%;
            text-align: center;
        }

    }

    }
</style>
